import React from 'react';

import { CheckIcon } from '../../../assets/icons';
import * as Styled from './styles';

/**
 * Componente de barra de progresso passo a passo.
 * @param {object} props - Propriedades do componente.
 * @param {string[]} props.steps - Lista de títulos de cada etapa.
 * @param {number} props.currentStepNumber - Número da etapa atual.
 * @param {string} [props.className] - Classe CSS adicional para estilização personalizada.
 * @returns {JSX.Element} O componente Stepper.
 */
export const Stepper = ({ steps, currentStepNumber, className }) => {
	return (
		<Styled.Container className={className}>
			<ol>
				{steps.map((step, index) => {
					const stepNumber = ++index;
					const isCurrentStep = stepNumber === currentStepNumber;
					const isPreviousStep = stepNumber < currentStepNumber;
					const stepType = isCurrentStep ? 'current' : isPreviousStep ? 'previous' : '';
					return <Step key={index} title={step} type={stepType} stepNumber={stepNumber} currentStep={currentStepNumber} />;
				})}
			</ol>
		</Styled.Container>
	);
};

/**
 * Componente de etapa de barra de progresso.
 * @param {object} props - Propriedades do componente.
 * @param {string} props.title - Título da etapa.
 * @param {number} props.stepNumber - Número da etapa.
 * @param {string} [props.className] - Classe CSS adicional para estilização personalizada.
 * @param {string} props.type - Tipo da etapa ("current", "previous" ou vazio).
 * @returns {JSX.Element} O componente Step.
 */
export const Step = ({ title, stepNumber, className, type }) => {
	return (
		<Styled.StepItem>
			<div className={`${type} ${className}`}>
				<span>{type === 'previous' ? <CheckIcon /> : stepNumber}</span>
			</div>
			<span className="stepTitle">
				<p className={type !== 'current' && 'displayNoneMobile'}>{title}</p>
			</span>
		</Styled.StepItem>
	);
};
